export class RoutesModel {
    public state: currentState;
    public waypoints: waypoint[];
    public request;
    constructor(public id: number, public name: string, public originName: string, public destinationName: string,
        public routeCode: string, public origin: string, public destination: string, public distance: number) {
        this.waypoints = [];
        this.state = {
            traffic: false,
            delay: 0
        };
    }

    setWaypoint(waypoints): void {
        this.waypoints = waypoints;
    }
    getRouteRequest(): any {
        this.request = {
            origin: this.origin,
            destination: this.destination,
            waypoints: this.waypoints,
            travelMode: 'DRIVING'
        };
        return this.request;
    }

}
export interface currentState {
    traffic: boolean;
    delay: number;
}

export interface waypoint {
    location: any;
    stopover: any;
}



// WEBPACK FOOTER //
// ./src/app/services/routes-data/routes-model.ts